// Expiry actions (for tickets, contracts, etc.)

export const SET_EXPIRING_TICKETS = "SET_EXPIRING_TICKETS";
export const DISMISS_TICKET_TOAST = "DISMISS_TICKET_TOAST";
export const SHOW_TICKET_MODAL = "SHOW_TICKET_MODAL";
export const HIDE_TICKET_MODAL = "HIDE_TICKET_MODAL";

/**
 * Set expiring items in Redux store
 * @param {Array} tickets - Array of expiring ticket/contract objects
 */
export const setExpiringTickets = (tickets) => ({
  type: SET_EXPIRING_TICKETS,
  payload: tickets
});

/**
 * Dismiss the expiration toast
 */
export const dismissTicketToast = () => ({
  type: DISMISS_TICKET_TOAST
});

/**
 * Show the expiration modal
 */
export const showTicketModal = () => ({
  type: SHOW_TICKET_MODAL
});

/**
 * Hide the expiration modal
 */
export const hideTicketModal = () => ({
  type: HIDE_TICKET_MODAL
});
